import React, { useContext, useMemo } from "react"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import { RegionContext } from "@/context/region"
import { maxAnnualDiscountForRegion } from "@/data/plans"

const PlanFrequencyToggle = ({ onChange, snapshot = false }) => {
  const { t } = useTranslation()

  const { region } = useContext(RegionContext)

  const annualDiscount = useMemo(
    () => maxAnnualDiscountForRegion(region),
    [region],
  )

  return (
    <div className="plan-frequency-toggle">
      <span className="plan-frequency-toggle__option-text">
        {t("plans.pay-annually")}{" "}
        {annualDiscount >= 5 && (
          <span
            className={`plan-frequency-toggle__annual-saving ${
              snapshot ? "plan-frequency-toggle__annual-saving--snapshot" : ""
            }`}
          >
            ({t("plans.annual-savings", { annualDiscount })})
          </span>
        )}
      </span>

      <label
        className={`plan-frequency-toggle__switch-container ${
          snapshot ? "plan-frequency-toggle__switch-container--snapshot" : ""
        }`}
      >
        <input
          type="checkbox"
          onChange={e =>
            onChange(e.target.checked === true ? "MONTHLY" : "ANNUAL")
          }
        />
        <span className="plan-frequency-toggle__switch"></span>
      </label>

      <span className="plan-frequency-toggle__option-text">
        {t("plans.pay-monthly")}
      </span>
    </div>
  )
}

export default PlanFrequencyToggle
